import { Injectable } from '@angular/core';
import { HttpService } from '../http.service';

@Injectable({
  providedIn: 'root',
})
export class OrderApiService {
  constructor(private http: HttpService) {}

  buildurl(path: string, queryMap: any = null): string {
    return this.http.buildurl('/order' + path, queryMap);
  }

  createUserOrder(
    busTypeID: number,
    exclusive: boolean,
    payScore: number,
    username: string,
    password: string,
    backup_security_codeOne: string,
    backup_security_codeTwo: string,
    busSeatID: number,
    couponCode: string,
    region_submit: string,
  ) {
    const url = this.buildurl('/order');
    const body = {
      bus_type_id: busTypeID,
      exclusive,
      pay_score: payScore,
      username,
      password,
      backup_security_codeOne,
      backup_security_codeTwo,
      bus_seat_id: busSeatID,
      coupon_code: couponCode,
      region_submit,
    };
    return this.http.post(url, body);
  }

  findUserOrders(
    query: string,
    status: string,
    page: number,
    pageSize: number,
  ) {
    const q = { query, status, page, page_size: pageSize };
    const url = this.buildurl('/orders', q);
    return this.http.fget(url);
  }

  getUserOrder(id: string) {
    const url = this.buildurl(`/order/${id}`);
    return this.http.fget(url);
  }

  cancelUserOrder(id: string) {
    const url = this.buildurl(`/order/${id}/cancel`);
    return this.http.put(url, {});
  }

  deleteUserOrder(id: string) {
    const url = this.buildurl(`/order/${id}`);
    return this.http.delete(url);
  }

  payUserOrder(
    id: string,
    method: string,
    isInWeChat: boolean,
    payMethodType: string = '',
    payMethodName: string = '',
  ) {
    const url = this.buildurl(`/order/${id}/pay`);
    const body = {
      method,
      is_in_wechat: isInWeChat,
      pay_method_type: payMethodType,
      pay_method_name: payMethodName,
    };
    return this.http.post(url, body);
  }

  alipayUserOrder(id: string) {
    const url = this.buildurl(`/order/${id}/alipay`);
    const body = {};
    return this.http.post(url, body);
  }

  getCouponCode(code: string, busTypeID: number = 0, busSeatID: number = 0) {
    const q = { bus_type_id: busTypeID, bus_seat_id: busSeatID };
    const url = this.buildurl(`/coupon/code/${code}`, q);
    return this.http.fget(url);
  }

  getLink(id: number, name: string) {
    const url = this.buildurl(`/netfilx/${id}/link`, { name });
    return this.http.fget(url);
  }

  getSelectLink(id: number, name: string) {
    const url = this.buildurl(`/netfilx/${id}/selectlink`, { name });
    return this.http.fget(url);
  }

  getGPTCode(id: number) {
    const url = this.buildurl(`/gpt/${id}/code`);
    return this.http.fget(url);
  }

  getGPTSelectCode(id: number) {
    const url = this.buildurl(`/gpt/${id}/selectcode`);
    return this.http.fget(url);
  }

  getSpotifyCode(id: number) {
    const url = this.buildurl(`/spotify/${id}/code`);
    return this.http.fget(url);
  }

  getSpotifySelectCode(id: number) {
    const url = this.buildurl(`/spotify/${id}/selectcode`);
    return this.http.fget(url);
  }

  getDisneyCode(id: number) {
    const url = this.buildurl(`/disney/${id}/code`);
    return this.http.fget(url);
  }

  getDisneySelectCode(id: number) {
    const url = this.buildurl(`/disney/${id}/selectcode`);
    return this.http.fget(url);
  }

  changeYoutubeGroup(bus_seat_id: number) {
    const body = { bus_seat_id };
    const url = this.buildurl('/changegroup ');
    return this.http.post(url, body);
  }

  enterYoutubeEmail(
    seat_id: number,
    user_name: string,
    password: string,
    one_code: string,
    two_code: string,
  ) {
    const body = { seat_id, user_name, password, one_code, two_code };
    const url = this.buildurl('/bus/seat/rejoin');
    return this.http.post(url, body);
  }

  getRepairTime(seat_id: number) {
    const url = this.buildurl('/get/compensationduration', { seat_id });
    return this.http.fget(url);
  }

  getSunoCode(id: number) {
    const url = this.buildurl(`/suno/${id}/code`);
    return this.http.fget(url);
  }

  getSunoSelectCode(id: number) {
    const url = this.buildurl(`/suno/${id}/selectcode`);
    return this.http.fget(url);
  }

  youtubeToCharge(
    seat_id: number,
    email: string,
    password: string,
    backup_code_1: string,
    backup_code_2: string,
    region: string,
  ) {
    const body = {
      seat_id,
      email,
      password,
      backup_code_1,
      backup_code_2,
      region,
    };
    const url = this.buildurl('/convert/youtube/personal');
    return this.http.post(url, body);
  }

  postRefund(order_id: string, method: string, reason: string) {
    const body = { order_id, method, reason };
    const url = this.buildurl('/twenty-four/hours/refund');
    return this.http.post(url, body);
  }

  findRefundLogs(id: number) {
    const url = this.buildurl(`/refund/${id}`);
    return this.http.fget(url);
  }

  postRefundLog(id: number, content: string) {
    const body = { content };
    const url = this.buildurl(`/refund/${id}/messages`);
    return this.http.post(url, body);
  }
}
